import { GroupStep, State } from "~/lib/pipeline";
import { useSteps } from "~/components/build/Show/lib/useSteps";
import { useCallback } from "react";
import { Step } from "~/components/build/Show/lib/types";

// @deprecated
const useCalculateCounts = (step: GroupStep) => {
  const { groupStepsMap } = useSteps();

  return useCallback(() => {
    const children: Step[] = groupStepsMap.get(step.uuid) || [];

    const filteredChildren = children.filter(
      (step) => step.type !== "wait" && step.state !== State.Ignored,
    );

    const finishedCount = filteredChildren.filter((step) => step.state === State.Finished).length;

    return {
      finishedCount,
      totalCount: filteredChildren.length,
    };
  }, [groupStepsMap, step]);
};

// Given group of steps, display a count of the number of finished steps in that group.
export const GroupStepCount = ({ step }: { step: GroupStep }) => {
  const calculateCounts = useCalculateCounts(step);
  let finishedCount: number, totalCount: number;

  if (Features.BuildSidebar) {
    // Fetch counts from the stats when progressively loading the build.
    finishedCount = step.statistics?.stepChildrenFinishedCount || 0;
    totalCount = step.statistics?.stepChildrenCount || 0;
  } else {
    // Otherwise calculate since we've got all the children.
    const calculated = calculateCounts();
    finishedCount = calculated.finishedCount || 0;
    totalCount = calculated.totalCount || 0;
  }

  return (
    <span className="text-charcoal-700 rounded-sm border border-slate-500 bg-white px-1 tabular-nums">
      {finishedCount}/{totalCount}
    </span>
  );
};
